import gql from 'graphql-tag'

export const REDEEM_CODE = gql`
  mutation redeemCode($competitionCode: String!) {
    redeemCode(competitionCode: $competitionCode) {
      status
      errors
      competitionCode {
        code
        team {
          gradeLevel
        }
      }
    }
  }
`

export const COMPETITION_CODES = gql`
  query competitionCodes {
    competitionCodes {
      id
      code
      gradeLevel
      batch {
        season
        gradeLevel
        files {
          url
          name
        }
      }
      state
      entries {
        product {
          name
        }
        categoryScores {
          assessment
          name
          score
        }
        isComplete
      }
      team {
        name
        sgcCode
      }
    }
  }
`

export const CREATE_ENTRY = gql`
  mutation createEntry($competitionCodeId: Int!, $competitionId: Int, $productId: Int, $category: String, $presentationUrl: String, $videos: [EmbedInput!], $isComplete: Boolean, $liveEventId: Int ) {
    createEntry(competitionCodeId: $competitionCodeId, competitionId: $competitionId, productId: $productId, category: $category, presentationUrl: $presentationUrl, videos: $videos, isComplete: $isComplete, liveEventId: $liveEventId) {
      status
      errors
      entry {
        category
      }
    }
  }
`

export const UPDATE_ENTRY = gql`
  mutation updateEntry($id: Int!, $productId: Int, $category: String, $presentationUrl: String, $videos: [EmbedInput!], $isComplete: Boolean, $liveEventId: Int ) {
    updateEntry(id: $id, productId: $productId, category: $category, presentationUrl: $presentationUrl, videos: $videos, isComplete: $isComplete, liveEventId: $liveEventId) {
      status
      errors
      entry {
        category
      }
    }
  }
`

export const REMOVE_ENTRY = gql`
  mutation removeEntry($id: Int!, $competitionCodeId: Int!) {
    removeEntry(id: $id, competitionCodeId: $competitionCodeId) {
      status
      errors
    }
  }
`

export const PRODUCTS_LIST = gql`
  query products {
    products {
      id
      name
    }
  }
`

export const LIVE_EVENTS = gql`
  query liveEvents($season: Int) {
    liveEvents(season: $season) {
      id
      city
      state
      startOn
      endOn
    }
  }
`

export const GET_COMPETITIONS = gql`
  query competitions($season: Int, $productId: Int, $gradeLevel: [String!]) {
    competitions(season: $season, productId: $productId, gradeLevel: $gradeLevel) {
      id
      name
      product {
        id
        name
      }
    }
  }
`

export const UPSERT_TEAM = gql`
  mutation upsertTeam(
    $name: String
    $code: String!
    $classType: String
    $hasSecurity: Boolean
    $gradeLevel: String
    $roster: [StudentInput!]
    $email: String
    $tagList: String
    $organizationId: Int
    $appName: String = "Sphero Central"
  ) {
    upsertTeam(
      name: $name
      code: $code
      classType: $classType
      hasSecurity: $hasSecurity
      gradeLevel: $gradeLevel
      roster: $roster
      email: $email
      tagList: $tagList
      organizationId: $organizationId
      appName: $appName
    ) {
      status
      errors
      classroom {
        name
        rosters {
          firstName
          lastName
        }
      }
    }
  }
`

export const ENTRIES_BY_CODE = gql`
  query entriesByCode($competitionCodeId: Int!) {
    entriesByCode(competitionCodeId: $competitionCodeId) {
      id
      competitionCode {
        batch {
          season
        }
      }
      category
      product {
        id
        name
      }
      team {
        id
        name
        code
        rosters {
          firstName
          lastName
        }
      }
      isComplete
      presentationUrl
      videos {
        url
      }
      liveEvent {
        id
      }
    }
  }
`

export const UPDATE_COACH = gql`
  mutation updateUserProfile($accountInfo: AccountInfoInput, $username: String, $email: String! ) {
    updateUserProfile(accountInfo: $accountInfo, username: $username, email: $email) {
      status
      errors
      user {
        username
        email
        accountInfo {
          city
          country
          organizationName
          phoneNumber
          postalCode
          state
          street
          fullName
        }
      }
    }
  }
`

export const GET_COACH_INFO = gql`
  query User {
    user {
      accountInfo {
        city
        country
        fullName
        organizationName
        phoneNumber
        postalCode
        state
        street
      }
    }
  }
`

export const GET_SGC_RESOURCES = gql`
  query sgcResources($season: Int, $productLine: String, $robot: String, $language: String) {
    sgcResources(season: $season, productLine: $productLine, robot: $robot, language: $language) {
      id
      name
      segment
      category
      description
      educationResourcesGroups {
        position
        asset {
          ... on DocumentLink {
            url
            title
          }
          ... on File {
            url
            title
          }
          ... on Video {
            url
            title
          }
        }
      }
      documentLinks {
        url
        title
      }
      files {
        url
        title
      }
      videos {
        url
        title
      }
      images {
        url
      }
      name
      slug
    }
  }
`

export const COMPETITION_CODE = gql`
  query competitionCode($id: Int!) {
    competitionCode(id: $id) {
      id
      code
      team {
        id
        name
        code
        rosters {
          firstName
          lastName
        }
      }
    }
  }
`

export const UPDATE_COMPETITION_CODE = gql`
  mutation updateCompetitionCode($competitionCodeId: Int!, $competitionId: Int, $productId: Int) {
    updateCompetitionCode(competitionCodeId: $competitionCodeId, competitionId: $competitionId, productId: $productId) {
      id
      code
      competition {
        id
        name
      }
      entries {
        id
        product {
          id
          name
        }
      }
    }
  }
`

export const BULK_MANAGE_ENTRIES = gql`
  mutation manageEntries($competitionCodeId: Int!, $entries: [EntryInput!]!) {
    manageEntries(competitionCodeId: $competitionCodeId, entries: $entries) {
      status
      errors
      entries {
        id
        category
        product {
          id
          name
        }
        team {
          id
          name
        }
        isComplete
        presentationUrl
        videos {
          url
        }
        liveEvent {
          id
        }
      }
    }
  }
`
